import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import axios from "axios";

var ComparableRentsData =
/*#__PURE__*/
function () {
  function ComparableRentsData() {
    _classCallCheck(this, ComparableRentsData);
  }

  _createClass(ComparableRentsData, [{
    key: "GetComparableRents",
    value: function () {
      var _GetComparableRents = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(projectId, numberOfProperties) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("/api/GetComparableRents/".concat(projectId, "/").concat(numberOfProperties)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function GetComparableRents(_x, _x2) {
        return _GetComparableRents.apply(this, arguments);
      }

      return GetComparableRents;
    }()
  }]);

  return ComparableRentsData;
}();

export default new ComparableRentsData();